import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	noDataStateHeaderText: {
		id: 'custom-sites-extensions.link-cards.error-states.no-data.header-text',
		defaultMessage: 'No data to display',
		description:
			'Header text shown when a cards extension or config panel cannot be rendered because data is missing',
	},
	noDataStateDescription: {
		id: 'custom-sites-extensions.link-cards.error-states.no-data.description-text',
		defaultMessage: 'Try deleting this macro and creating a new one.',
		description:
			'Describes possible action when cards extension or config panel is unable to render because of no data',
	},
});
